export const VERTEX_RADIUS = 35